// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"cfe67d1e","87":"081b07b5","121":"ac25f5c1","163":"ed0801dd","251":"1a4ffae7","354":"09788cca","444":"2215e09d","460":"e92cc32f","606":"9c4b4aa6","693":"e87a987e","767":"4d7046a0"}[chunkId] + ".chunk.js";
};